exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Notifications__title___dS32h {\n\tcolor: #777;\n}\n\n.Notifications__subTitle___1d_Ng {\n\tdisplay: flex;\n\talign-items: center;\n\tfont-weight: 300;\n}\n\n.Notifications__subTitleText___1SzKU {\n\tmargin-left: 0.25rem;\n\tdisplay: flex;\n\talign-items: center;\n\tcolor: #000;\n\tfont-weight: bold;\n}\n\n.Notifications__image___2vIdE {\n\tposition: relative;\n\tright: 0;\n\theight: 3rem;\n\twidth: 3rem;\n\tbox-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.05);\n\tmargin-left: 0.25rem;\n}\n", ""]);

// exports
exports.locals = {
	"title": "Notifications__title___dS32h",
	"subTitle": "Notifications__subTitle___1d_Ng",
	"subTitleText": "Notifications__subTitleText___1SzKU",
	"image": "Notifications__image___2vIdE"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/Notifications.icss
// module id = 1456
// module chunks = 0